import { transformImages } from '@/helpers/transforms'
import type { TextWithGalleryAsideBlock } from '@/payload-types'
import type { SerializedBlockNode } from '@payloadcms/richtext-lexical'
import type { JSXConverter } from '@payloadcms/richtext-lexical/react'
import { CMSBlocks } from '../atoms/CMSBlocks'
import { ColumnsBlock } from '../blocks/ColumnsBlock'
import { ImageGrid } from '../molecules/ImageGrid'

export const TextWithGalleryAsideConverter: JSXConverter<
	SerializedBlockNode<TextWithGalleryAsideBlock>
> = ({ node, nodesToJSX }) => {
	const { content, gallery, layout } = node.fields

	const columnLayout = layout === 'gallery-on-right' ? 'default' : 'reverse'

	const imageData = transformImages(gallery)

	const richTextContent = (
		<CMSBlocks>{nodesToJSX({ nodes: content?.root?.children ?? [] })}</CMSBlocks>
	)

	return (
		<ColumnsBlock columnLeft={richTextContent} columnLayout={columnLayout}>
			<ImageGrid images={imageData} />
		</ColumnsBlock>
	)
}
